
document.addEventListener('DOMContentLoaded', function () {
  var splideElements = document.querySelectorAll('.vsr-slider');

  splideElements.forEach(function(splideElement) {


    
    var splide = new Splide(splideElement, {
      type: 'loop',
      autoplay: true,
      interval: 3000,
    lazyLoad: 'nearby',
       perPage: 1,
    perMove: 1,
       arrows: false,
       speed: 2000, // Transition speed in milliseconds (1 second)
        pagination: false
    });

  
    // Add event listener to pause autoplay and allow the link to open
    splideElement.querySelectorAll('.splide__slide a').forEach(function(link) {
      link.addEventListener('click', function(event) {
        // Pause autoplay
        splide.Components.Autoplay.pause();

        // Let the link open normally
        var href = this.getAttribute('href');
        if (href) {
          window.open(href, '_self'); // Opens the link in the same tab
        }
      });
    });

 
    
    
    splide.mount();
  });
}); 

